import I1 from '../img/i1.png';
import F1 from '../img/f1.png';
import C3 from '../img/c3.png';
import Fi1 from '../img/fi1.png';

export const heropData = [
  {
    id: 1,
    name: 'Icecream',
    decp: 'Chocolate & vanilla',
    price: '5.25',
    imageScr: I1,
  },
  {
    id: 2,
    name: 'Strawberries',
    decp: 'Fresh strawberries',
    price: '10.25',
    imageScr: F1,
  },
  {
    id: 3,
    name: 'Chicken Kebab',
    decp: 'Mix Kebab Plate',
    price: '8.25',
    imageScr: C3,
  },
  {
    id: 4,
    name: 'Fish Kebab',
    decp: 'Mixed Fish Kebab',
    price: '5.25',
    imageScr: Fi1,
  },
];

export const categories = [
  {
    id: 1,
    name: 'Chicken',
    urlParamName: 'chicken',
  },
  {
    id: 2,
    name: 'Curry',
    urlParamName: 'curry',
  },
  {
    id: 3,
    name: 'Rice',
    urlParamName: 'rice',
  },
  {
    id: 4,
    name: 'Fish',
    urlParamName: 'fish',
  },
  {
    id: 5,
    name: 'Fruits',
    urlParamName: 'fruits',
  },
  {
    id: 6,
    name: 'Icecreams',
    urlParamName: 'icecreams',
  },

  {
    id: 7,
    name: 'Soft Drinks',
    urlParamName: 'drinks',
  },
];
